import { AuthGuard, accessGuard } from "@dis/auth";
import { SEND_OUT_ACCESS } from "../feature/shop/ship-n-receiving/vendor-orders/vendor-orders.model";
import { JtmsRoutes, groupOverview } from "../core/routing/route-data";

export default [
  {
    path: "",
    canMatch: [AuthGuard],
    data: { navGroup: "purchasing" },
    children: [
      groupOverview(() => import("../feature/overviews/purchasing-overview").then((m) => m.PurchasingOverview)),
      {
        path: "vendor-orders",
        data: { navOrder: 1 },
        loadComponent: () =>
          import("../feature/shop/ship-n-receiving/vendor-orders/vendor-orders.component").then((m) => m.VendorOrders),
        title: "Vendor Orders",
        children: [
          { path: "", pathMatch: "full", redirectTo: "open" },
          {
            path: "open",
            loadComponent: () =>
              import("../feature/shop/ship-n-receiving/vendor-orders/at-vendor/at-vendor.component").then(
                (m) => m.AtVendor
              ),
            title: "Vendor Orders",
          },
          {
            path: "send-out",
            canActivate: [accessGuard(SEND_OUT_ACCESS.domain, SEND_OUT_ACCESS.level, SEND_OUT_ACCESS.target)],
            loadComponent: () =>
              import("../feature/shop/ship-n-receiving/vendor-orders/send-out/send-out.component").then(
                (m) => m.SendOut
              ),
            title: "Send Out",
          },
          {
            path: "all",
            loadComponent: () =>
              import("../feature/shop/ship-n-receiving/vendor-orders/table/vendor-orders-table.component").then(
                (m) => m.VendorOrdersTable
              ),
            title: "All Vendor Orders",
          },
        ],
      },
      {
        // Matches the createPurchaseOrderComponents/uploadDriveFile/findDrawingFiles callables: Purchasing at a site the user picks.
        path: "components/new",
        canActivate: [accessGuard("PURCHASING", "EDITOR", "anywhere")],
        data: { navOrder: 2, scopes: [{ domain: "PURCHASING", level: "EDITOR", target: "anywhere" }] },
        loadComponent: () =>
          import("../feature/components/new-component/new-component.component").then((m) => m.NewComponentComponent),
        title: "New Component / PO Packet",
      },
      {
        path: "scan-manager",
        data: { navOrder: 3 },
        loadComponent: () =>
          import("../feature/office/scan-manager/scan-manager.component").then((m) => m.ScanManagerComponent),
        title: "Scan Manager",
      },
    ],
  },
] satisfies JtmsRoutes;
